import {useState} from 'react'
import content from '../content.json'
import HowToVideos from './HowToVideos'

export const HowItWorks = () => {
    const [sections, setSections] = useState([true, false, false])

    const onSectionOpen = (e, sectionState) => {
        e.preventDefault()
        setSections(sectionState)
    }

    return (
        <section id='how-it-works' className={'how-it-works-wrapper'}>
            <h2 className={'section-header'}>{content?.howItWorksTitle}</h2>
            <div className={'how-it-works-inner-wrapper'}>
                <div className={'how-it-works-steps'}>
                    <details open={sections[0]}>
                        <summary onClick={(e) => onSectionOpen(e,[true, false, false])}>
                            <h3 className={'summary-header'}>{content?.steps[0]?.title}</h3>
                            <span aria-hidden="true" className="material-symbols-outlined">add</span>
                        </summary>
                        <div className={'answer-text'}>
                            <ul>
                                {content?.steps[0]?.text && content?.steps[0]?.text.map((item, index) => (
                                    <li key={content?.steps[0]?.title + index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </details>
                    <details open={sections[1]}>
                        <summary onClick={(e) => onSectionOpen(e, [false, true, false])}>
                            <h3 className={'summary-header'}>{content?.steps[1]?.title}</h3>
                            <span aria-hidden="true" className="material-symbols-outlined">add</span>
                        </summary>
                        <div className={'answer-text'}>
                            <ul>
                                {content?.steps[1]?.text && content?.steps[1]?.text.map((item, index) => (
                                    <li key={content?.steps[1]?.title + index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </details>
                    <details open={sections[2]}>
                        <summary onClick={(e) => onSectionOpen(e, [false, false, true])}>
                            <h3 className={'summary-header'}>{content?.steps[2]?.title}</h3>
                            <span aria-hidden="true" className="material-symbols-outlined">add</span>
                        </summary>
                        <div className={'answer-text'}>
                            <ul>
                                {content?.steps[2]?.text && content?.steps[2]?.text.map((item, index) => (
                                    <li key={content?.steps[2]?.title + index}>{item}</li>
                                ))}
                            </ul>
                        </div>
                    </details>
                </div>
                <HowToVideos sections={sections}/>
            </div>
        </section>
    )
}